// extracted by mini-css-extract-plugin
export var attachment = "_lr-a";
export var emailContainer = "_lr-4";
export var emailContentPaddedContainer = "_lr-b";
export var emailHeader = "_lr-6";
export var emailIframe = "_lr-3";
export var emailInfoIcon = "_lr-9";
export var emailShortenedSummary = "_lr-e";
export var infoDropdown = "_lr-0";
export var infoRowBoundedContent = "_lr-d";
export var internal = "_lr-5";
export var merchant = "_lr-8";
export var messageInputContainer = "_lr-h";
export var normal = "_lr-7";
export var replyCard = "_lr-f";
export var subtleButton = "_lr-1";
export var subtleButtonIconContainer = "_lr-2";
export var toggleViewRepliesButton = "_lr-c";
export var wrappingText = "_lr-g";